<div  id="card-carousel" class="row">
  <div  id="div1mobile">
    <img  id="logodesk" src="/assets/p2.jpg" alt="Logo" class="img-thumbnail">
  </div>
  <div  id="div2mobile">
    <h1  id="scritta11"> "Un corpo e una mente complici,</h1>
    <h1 id="scritta22">...arrivano ovunque."</h1>
  </div>
  <div id="imma5" class="col-md-3 col-sm-12 col-xs-12">
    <img  id="imma" src="/assets/header.png" alt="Logo">
  </div>
  <div id="scritta" class="col-md-9">
    <h1 id="scritta1"> "Un corpo e una mente complici,</h1>
    <h1 id="scritta2">...arrivano ovunque."</h1>
    <img  id="logo" src="/assets/p2.jpg" alt="Logo" class="img-thumbnail">
  </div>
</div>
